<template>
  <el-card>
    <div slot="header" class="clearfix">
      <el-col :lg="4">
        <el-page-header @back="$router.push({ name: 'pdv' })" title content="Lista de Autorizações"></el-page-header>
      </el-col>
      <el-col :lg="20" class="right" style="text-align: right;">
        <el-button type="warning" autofocus @click="$router.push({ name: 'pdv.authorization.reverse.pendencies' })">Ver
          Pendências</el-button>
      </el-col>
    </div>
    <br />
    <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px" :inline="true">
      <el-row :gutter="5" v-if="userType === '1'">
        <el-col :xs="12" :sm="6" :md="6" :lg="12" :xl="12">
          <el-form-item :label="$t('licenca')" prop="licence" class="is-required" v-if="userType === '1'">
            <CustomerList v-model="ruleForm.customer" :customerType="2" :multiple="false" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item :label="$t('data')" prop="range" class="is-required">
            <el-date-picker v-model="ruleForm.range" type="daterange" align="right" unlink-panels clearable
              range-separator="à" format="dd/MM/yyyy" start-placeholder="Inicio" end-placeholder="Fim"></el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('atendimento')" prop="id">
            <el-input-number :controls="false" :precision="0" :step="1" v-model="ruleForm.id" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :xs="12" :sm="6" :md="6" :lg="12" :xl="12">
          <el-form-item :label="$t('autorizacao')" prop="authorization">
            <el-input v-model="ruleForm.authorization" maxlength="20" />
          </el-form-item>
          <el-form-item :label="$t('etiqueta')" prop="tag">
            <el-input v-model="ruleForm.tag" maxlength="20" />
          </el-form-item>
          <el-button type="info" @click="fetch()">Filtrar</el-button>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="12" :xl="12">
          <el-button class="right" type="text" @click="pdf()"><i class="fa fa-file-pdf-o"
              aria-hidden="true"></i>&nbsp;PDF</el-button>
          <el-button class="right" type="text" @click="csv()"><i class="fa fa-file-excel-o"
              aria-hidden="true"></i>&nbsp;CSV&nbsp;</el-button>
        </el-col>
      </el-row>
    </el-form>
    <br />
    <el-table ref="tableData" :data="tableList" size="small" stripe>
      <el-table-column sortable prop="callId" :label="$t('atendimento')" />
      <el-table-column sortable prop="createdAt" :label="$t('data')">
        <template slot-scope="scope">
          {{ scope.row.createdAt | formatDateHour }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="userName" :label="$t('atendente')" />
      <el-table-column sortable prop="name" :label="$t('cliente')" />
      <el-table-column sortable prop="phone" :label="$t('telefone')" />
      <el-table-column sortable prop="mail" :label="$t('email')" />
      <el-table-column sortable prop="cpfcnpj" label="CPF/CNPJ" show-overflow-tooltip />
      <el-table-column prop="content" label="Conteúdo" min-width="140" show-overflow-tooltip />
      <el-table-column sortable prop="authorization" :label="$t('autorizacao')" />
      <el-table-column sortable prop="tag" :label="$t('etiqueta')" />
    </el-table>
  </el-card>
</template>

<script>
import { UserService } from "@/services/users/user.services";
import { PdvService } from "@/services/pdv/pdv.services";
import { i18n } from "@/plugin/i18n";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  components: {
    CustomerList,
  },
  data() {
    return {
      userType: '2',
      tableList: [],
      ruleForm: {
        range: [new Date(), new Date()],
        customer: '',
        authorization: '',
        tag: '',
        id: 0,
      }
    }
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((user) => {
        vm.userType = user.type;
        if (vm.userType !== '1') {
          vm.fetch();
        }
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
          offset: 45,
        });
      });
  },
  methods: {
    pdf() {
      this.fetch({
        action: 'export',
        type: 'pdf'
      })
    },
    csv() {
      this.fetch({
        action: 'export',
        type: 'csv'
      })
    },
    fetch(options) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const s = moment(vm.ruleForm.range[0]);
      const f = moment(vm.ruleForm.range[1]);
      if (!options) {
        options = {
          action: 'table',
          type: ''
        }
      }
      PdvService.authorization(vm.ruleForm.customer, vm.ruleForm.authorization, vm.ruleForm.tag, s.format("YYYY-MM-DD"), f.format("YYYY-MM-DD"), vm.ruleForm.id, options.action, options.type)
        .then((response) => {
          if (options.action !== 'export') {
            vm.tableList = response.data;
          } else {
            var downloadLink = document.createElement("a");
            downloadLink.href = response.data;
            downloadLink.download = `reversa.${options.type}`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          }
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error }))
        .finally(() => loading.close());
    },
    save() {
      const vm = this;
      if (vm.tableList.filter(x => x.tag).length === 0) {
        return vm.$message({ type: "error", duration: 5000, message: 'É preciso informar ao menos uma etiqueta', offset: 45 })
      }
      PdvService.down(vm.tableList.filter(x => x.tag).map((x) => {
        return {
          id: x.id,
          tag: x.tag,
        }
      }))
        .then((response) => {
          vm.fetch();
          vm.$message({
            type: "success",
            duration: 5000,
            message: 'Etiquetas atualizadas com sucesso!',
            offset: 45,
          });
        })
        .catch((error) => this.$message({ type: "error", duration: 5000, message: error, offset: 45, }))
        .finally(() => loading.close());
    },
  }
}
</script>
